import type { challenges as en } from '@/i18n/locales/en/challenges';
import type { Translation } from '@/i18n/types';

/** See `src/i18n/locales/en/challenges.ts`. */
export const challenges: Translation<typeof en> = {
  page: {
    title: 'Challenges',
    lead: 'Organiseer teamchallenges: stappen, slaap, workouts en meer, met een optionele ranglijst.',
    noCompany: 'Selecteer een bedrijf om de challenges te zien.',
    forbidden: 'Je hebt geen toegang tot de challenges van dit bedrijf.',
    empty: 'Nog geen challenges — maak de eerste aan.',
  },
  counts: {
    active: 'Actieve challenges',
    draft: 'Concepten',
    completed: 'Afgerond',
    totalParticipants: 'Totaal deelnemers',
  },
  sections: {
    activePublished: 'Actief & gepubliceerd',
    draftsCompleted: 'Concepten & afgerond',
  },
  card: {
    type: 'Type',
    mode: 'Vorm',
    period: 'Periode',
    goal: 'Doel',
    reward: 'Beloning',
    participants: 'Deelnemers',
    engagement: 'Engagement',
    completion: 'Voltooiing',
    leaderboardVisible: 'Ranglijst zichtbaar',
    leaderboardHidden: 'Ranglijst verborgen',
  },
  mode: {
    individual: 'Individueel',
    group: 'Team',
  },
  status: {
    draft: 'Concept',
    active: 'Actief',
    paused: 'Gepauzeerd',
    completed: 'Afgerond',
  },
  type: {
    steps: 'Stappen',
    sleep: 'Slaap',
    workouts: 'Workouts',
    meditation: 'Meditatie',
    custom: 'Aangepast',
  },
  actions: {
    newChallenge: 'Nieuwe challenge',
    publish: 'Publiceren',
    pause: 'Pauzeren',
    resume: 'Hervatten',
    finish: 'Beëindigen',
    duplicate: 'Dupliceren als concept',
    duplicateSuffix: 'kopie',
    viewLeaderboard: 'Ranglijst bekijken',
    hideLeaderboard: 'Ranglijst verbergen',
  },
  leaderboard: {
    title: 'Ranglijst',
    empty: 'Nog geen deelnemers.',
  },
  form: {
    title: 'Nieuwe challenge',
    submit: 'Challenge aanmaken',
    cancel: 'Annuleren',
    fields: {
      title: 'Titel',
      description: 'Omschrijving',
      type: 'Type',
      mode: 'Vorm',
      startDate: 'Startdatum',
      endDate: 'Einddatum',
      goalValue: 'Doelwaarde',
      unit: 'Eenheid',
      reward: 'Beloning',
      leaderboardVisible: 'Ranglijst tonen aan deelnemers',
    },
    errors: {
      required: 'Dit veld is verplicht.',
      endBeforeStart: 'Einddatum mag niet vóór de startdatum liggen.',
    },
  },
};
